import script from "./DownloadCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCenter.vue?vue&type=script&setup=true&lang=js"

import "./DownloadCenter.vue?vue&type=style&index=0&id=59d756b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d756b6"]])

export default __exports__